export default "__VITE_ASSET__DykhhQST__"